import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const AssetsServices = {
  uploadMedia: (data: FormData) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}assets/public`, data);
  }
};
